// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label_component-layout {\n  font-family: var(--font-title);\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: black;\n  margin: 0px;\n  padding: 0px; }\n", ""]);
// Exports
module.exports = exports;
